import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'
import {
  actionTypes,
  checkRequirementEntitlementsActionFailure,
  checkRequirementEntitlementsActionSuccess,
  getEmergencyCheckActionFailure,
  getEmergencyCheckActionSuccess,
  getEmergencyTemporaryEntitlementsActionFailure,
  getEmergencyTemporaryEntitlementsActionSuccess,
  getFieldsSelectedTemporaryAbilitationFailure,
  getFieldsSelectedTemporaryAbilitationSuccess,
  getUserEntitlementForCheckFailure,
  getUserEntitlementForCheckSuccess,
  sendTemporaryAbilitationFailure,
  sendTemporaryAbilitationSuccess,
  temporaryAbilitationsFetchRequestFailure,
  temporaryAbilitationsFetchRequestSuccess,
} from './actions'
import {
  checkOwnedRequirementEntitlements,
  fetchUserTemporaryEntitlements,
  getEmergencyCheckService,
  getEmergencyEntitlementsService,
  getFieldsFromSelectedTemporaryAbilitation,
  getUserEntitlementAndBusinessRoleRequest,
  sendTemporaryAbilitationRequest,
} from './services'

const fetchUserEntitlementsForCheckEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST),
    mergeMap((action: any) =>
      getUserEntitlementAndBusinessRoleRequest(action.payload).pipe(
        map((response: any) => getUserEntitlementForCheckSuccess(response)),
        catchError((error: any) => of(getUserEntitlementForCheckFailure(error)))
      )
    )
  )

const fetchUserTemporaryEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST),
    mergeMap((action: any) =>
      fetchUserTemporaryEntitlements(action.payload).pipe(
        map((response: any) =>
          temporaryAbilitationsFetchRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(temporaryAbilitationsFetchRequestFailure(error))
        )
      )
    )
  )

const getFieldsFromSelectedTemporaryAbilitationEpic = (action$: any) =>
  action$.pipe(
    ofType(
      actionTypes.GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION
    ),
    mergeMap((action: any) =>
      getFieldsFromSelectedTemporaryAbilitation(action.payload).pipe(
        map((response: any) =>
          getFieldsSelectedTemporaryAbilitationSuccess(response)
        ),
        catchError((error: any) =>
          of(getFieldsSelectedTemporaryAbilitationFailure(error))
        )
      )
    )
  )

const sendTemporaryAbilitationRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SEND_TEMPORARY_ABILITATION_REQUEST_ACTION),
    mergeMap((action: any) =>
      sendTemporaryAbilitationRequest(action.payload).pipe(
        map((response: any) => sendTemporaryAbilitationSuccess(response)),
        catchError((error: any) => of(sendTemporaryAbilitationFailure(error)))
      )
    )
  )

const getEmergencyCheckEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_EMERGENCY_CHECK_REQUEST),
    mergeMap((action: any) =>
      getEmergencyCheckService().pipe(
        map((response: any) => getEmergencyCheckActionSuccess(response)),
        catchError((error: any) => of(getEmergencyCheckActionFailure(error)))
      )
    )
  )

const getEmergencyEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST),
    mergeMap((action: any) =>
      getEmergencyEntitlementsService(action.payload).pipe(
        map((response: any) =>
          getEmergencyTemporaryEntitlementsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(getEmergencyTemporaryEntitlementsActionFailure(error))
        )
      )
    )
  )

const checkRequirementEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CHECK_REQUIREMENT_ENTITLEMENTS),
    mergeMap((action: any) =>
      checkOwnedRequirementEntitlements(action.payload).pipe(
        map((response: any) =>
          checkRequirementEntitlementsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(checkRequirementEntitlementsActionFailure(error))
        )
      )
    )
  )

const epics = [
  fetchUserTemporaryEntitlementsEpic,
  sendTemporaryAbilitationRequestEpic,
  getFieldsFromSelectedTemporaryAbilitationEpic,
  fetchUserEntitlementsForCheckEpic,
  getEmergencyCheckEpic,
  getEmergencyEntitlementsEpic,
  checkRequirementEntitlementsEpic,
]

export default epics
